import { render, staticRenderFns } from "./PurchaseOrderDisplay.vue?vue&type=template&id=51a8b60e&scoped=true"
import script from "./PurchaseOrderDisplay.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderDisplay.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOrderDisplay.vue?vue&type=style&index=0&id=51a8b60e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a8b60e",
  null
  
)

export default component.exports